import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
              MacroFit
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="bg-gray-800 p-3 rounded-full hover:bg-teal-600 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="bg-gray-800 p-3 rounded-full hover:bg-teal-600 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="bg-gray-800 p-3 rounded-full hover:bg-teal-600 transition-colors">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="bg-gray-800 p-3 rounded-full hover:bg-teal-600 transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-teal-400 transition-colors">{t('footer.nutritionConsulting')}</a></li>
              <li><a href="#" className="hover:text-teal-400 transition-colors">{t('footer.macroTracking')}</a></li>
              <li><a href="#" className="hover:text-teal-400 transition-colors">{t('footer.mealDelivery')}</a></li>
              <li><a href="#" className="hover:text-teal-400 transition-colors">{t('footer.personalTraining')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-teal-400 transition-colors">{t('footer.aboutUs')}</a></li>
              <li><a href="#" className="hover:text-teal-400 transition-colors">{t('footer.careers')}</a></li>
              <li><a href="#" className="hover:text-teal-400 transition-colors">{t('footer.privacy')}</a></li>
              <li><a href="#" className="hover:text-teal-400 transition-colors">{t('footer.terms')}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 MacroFit. {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}